import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const api = new API(BASE_URL);

class LeaseService {
  static fetchApplicationDetails = id => api.get(urls.LEASE.APPLICATION_DETAILS, id);

  static fetchPremise = (premiseNumber, params) => api.get(urls.LEASE.PREMISE_DETAILS, premiseNumber, params);

  static fetchAllPremises = premiseNumber => api.post(urls.LEASE.PREMISE_DETAILS, premiseNumber);

  static fetchPerson = uid => api.get(urls.LEASE.USER_DETAILS, uid);

  static submitApplication = data => api.post(urls.LEASE.REGISTRATION, data);

  static addOccupant = data => api.post(urls.LEASE.ADD_OCCUPANT, data);

  static removeOccupant = (id, params) => api.delete(urls.LEASE.REMOVE_OCCUPANT, id, params);

  static fetchOccupantRelation = () => api.get(urls.LEASE.FETCH_OCCUPANT_RELATIONS);

  static uploadDocumentComplete = body => api.post(urls.DOCUMENT.DOCUMENT_COMPLETE, body);

  static getApplicationPDF = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/octet-stream;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.LEASE.APPLICATION_PDF_CONTRACT, appId);
  };

  static previewLeaseContract = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.LEASE.LEASE_CONTRACT_PREVIEW, appId);
  };

  static getApplicationPDFPma = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/octet-stream;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.LEASE.APPLICATION_PDF_CONTRACT_PMA, appId);
  };

  static getApplicationPDFApp = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.LEASE.APPLICATION_PDF, appId);
  };

  static checkoutApplication = appId => api.post(urls.LEASE.CHECKOUT, null, null, appId);

  static fetchContracts = (body, params) => api.post(urls.LEASE.CONTRACTS, body, params);

  static fetchAmendmentFee = () => api.get(urls.PAYMENT.AMENDMENT_FEE);

  static fetchProperty = propertyId => api.get(urls.PROPERTY_SERVICE.LEASE_PROPERTY, propertyId);

  static addPrimaryLessor = payload => api.post(urls.LEASE.ADD_PRIMARY_LESSOR, payload);

  static fetchUserByIdLease = id => api.get(urls.LEASE.FETCH_USER_BY_ID_LEASE, id);

  static getOnwaniAddress = id => {
    const url = urls.LEASE.GET_ONWANI_ADDRESS;

    return api.get(`${url}/${id}`);
  };

  static getOnwaniAddresses = payload => api.post(urls.LEASE.GET_ONWANI_ADDRESSES, payload);

  static addLeaseProperties = data => api.post(urls.LEASE.ADD_PROPERTIES, data);

  static getSelectedProperties = params => api.post(urls.LEASE.GET_SELECTED_PROPERTIES, null, params);

  static removeUnit = body => api.deleteWithBody(urls.LEASE.REMOVE_UNIT, null, body);

  static getContractAmount = data => api.post(urls.LEASE.GET_CONTRACT_AMOUNT, data);

  static updateSubleasePermissions = payload => api.put(urls.LEASE.UPDATE_SUBLEASE_PERMISSIONS, payload);
}

export default LeaseService;
